export default {
  NODE_ENV: process.env.REACT_APP_ENV,
  VERSION: '2.0.1',
  PUBLIC_URL: process.env.PUBLIC_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  SELFREG_URL:
    process.env.REACT_APP_SELFREG_URL || 'https://prepaidselfreg.m1.com.sg/',
  GLOBAL_HOSTNAME:
    process.env.REACT_APP_GLOBAL_HOSTNAME || 'prepaiddataselfreg.m1.com.sg',
  EID_URL:
    process.env.REACT_APP_EID_URL ||
    'https://etrust-m1limited.electronicid.eu/v2',
  EID_TOKEN:
    process.env.REACT_APP_EID_TOKEN || '1678e136-6696-429b-ba6a-520a6e427e75',
}
